
import React from 'react';
import {useTranslation} from "react-i18next";
import Helmet from "react-helmet";
import {Link} from "react-router-dom";
import Zoom from "react-medium-image-zoom";

function PressPage(props) {

    const { t, i18n } = useTranslation()

    const _photos2 = [
        // "https://placehold.co/600x400",
        "/assets/photo/7.jpeg",
        "/assets/photo/8.jpeg",
        "/assets/photo/10.jpg",
        "/assets/photo/9.jpg",
        // "https://zt-rada.gov.ua/files/upload/sitephotos/img1593175223_6.jpg",
    ];

    return (<div className={'container-fluid h-auto'}>

        <Helmet>
            <title>Press - Yaroslav Lukyanchuk</title>
            <meta name="description" content="Yaroslav Lukyanchuk" />
        </Helmet>

        <div className="container text-justify- mt-5">

            <div className="text-center">
                <h4 className={'opacity-25 display-1'}>Press & {t('nav.media')}</h4>
            </div>

            <div className="d-flex flex-wrap mt-5">
                <div className="col-md-6 col-12">
                    <img src="https://zt-rada.gov.ua/files/upload/sitepages/img1593175154.jpg" alt="cover" className={'img-fluid rounded-5'}/>
                </div>
                {/*<div className="cover mt-3" style={{width: '100%', height: '375px', objectFit: 'cover'}}></div>*/}
                <div className={'col-md-6 col-12 p-5'}>
                    <h3 className={''}>
                        Обдаровані житомирські студенти отримали стипендії міського голови
                    </h3>
                    <p className="text-justify">
                        Обдарована та перспективна житомирська молодь отримала сьогодні, 26 червня,  стипендії міського голови.

                        «Бажаю, щоб та енергія, яка є у вас сьогодні,  залишалася з вами назавжди. Як би важко не було в житті, творіть свій світ, і тоді все навколо зміниться…У вас ще все попереду… Перемагайте!  А моя мрія – щоб ви залишалися в Житомирі…» - звернувся Сергій Сухомлин до  студентів.
                    </p>
                    <Link to="https://zt-rada.gov.ua/?pages=11342" className={'p-1 nav-link'}>
                        <b className={'border-bottom'}>{t('know.more')}</b>
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor"
                             className="bi bi-arrow-up-right-square-fill m-1" viewBox="0 0 16 16">
                            <path
                                d="M14 0a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2zM5.904 10.803 10 6.707v2.768a.5.5 0 0 0 1 0V5.5a.5.5 0 0 0-.5-.5H6.525a.5.5 0 1 0 0 1h2.768l-4.096 4.096a.5.5 0 0 0 .707.707"/>
                        </svg>
                    </Link>
                </div>
            </div>
        </div>


        {/*<p className="text-justify mt-5 lead- display-4 text-secondary">*/}
        {/*    <small>Більше фотографій можна переглянути у мене в instagram</small>*/}
        {/*    <b className={'text-dark'}> @yariklukyanchuk</b>*/}
        {/*    <Link to={'https://instagram.com/@yariklukyanchuk'} target={'_blank'} className={'d-none'}>*/}
        {/*        <b className={'text-dark'}>@yariklukyanchuk</b>*/}
        {/*    </Link>*/}
        {/*</p>*/}

        {/*<div id={'media'} className="d-flex pt-5 mt-5">*/}
        {/*    {*/}
        {/*        _photos2.map((photo, i) =>  <div key={i} className="photo col-md-3 text-center about-img">*/}

        {/*            <Zoom> <img src={photo} alt={'photo_#' + i} className={'img-fluid photo-card card-'+(i+1)} /> </Zoom>*/}
        {/*        </div>)*/}
        {/*    }*/}
        {/*</div>*/}
        {/*TODO: show posts from https://lukyanchuk.com*/}
        {/*<Link to="https://blog.y-l.pro" target={'_blank'} className={'nav-link text-secondary text-decoration-none'}> {t('nav.blog')}</Link>*/}

    </div>);
}

export default PressPage;
